// extracted by mini-css-extract-plugin
module.exports = {"formMessage":"style_formMessage__rdp08"};